import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const StaffContactDetails = ({
  formData,
  handleChange,
  errors = {},
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white">
      <button
        type="button"
        onClick={() => setIsOpen((current) => !current)}
        className="flex w-full items-center justify-between border-b border-gray-100 px-6 py-4 text-left"
      >
        <div className="flex items-center gap-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 text-sm font-semibold text-white">
            3
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Additional Contact
            </h2>
            <p className="text-xs text-gray-500">
              Optional contact fields supported by the backend.
            </p>
          </div>
        </div>

        {isOpen ? (
          <ChevronUp className="h-5 w-5 text-gray-500" />
        ) : (
          <ChevronDown className="h-5 w-5 text-gray-500" />
        )}
      </button>

      {isOpen && (
        <div className="p-6">
          <label className="block max-w-xl">
            <span className="text-sm font-medium text-gray-700">
              Alternate Phone
              <span className="font-normal text-gray-400"> (Optional)</span>
            </span>
            <input
              type="tel"
              inputMode="tel"
              maxLength={20}
              name="alternatePhone"
              value={formData.alternatePhone}
              onChange={handleChange}
              placeholder="Enter alternate phone"
              className={`mt-2 h-12 w-full rounded-xl border px-4 text-sm outline-none transition ${
                errors.alternatePhone
                  ? 'border-red-400 bg-red-50 focus:border-red-500 focus:ring-2 focus:ring-red-100'
                  : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
              }`}
            />
            {errors.alternatePhone && (
              <p className="mt-1 text-xs font-medium text-red-600">
                {errors.alternatePhone}
              </p>
            )}
          </label>
        </div>
      )}
    </div>
  );
};

export default StaffContactDetails;
